import { useTranslation } from "react-i18next";
import { useSelector } from "src/store";
import { makeStyles } from "tss-react/mui";

import { selectBatchActionIsActiveDevice, selectBatchActionIsActiveLicense } from "@devices/store";
import { Theme } from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import { DangerOutlinedButton } from "@shared/CustomButton";
import { MinimalTable, MinimalTableCell, MinimalTableHeader, MinimalTableHeaderCell } from "@shared/table/MinimalTableComponents";

import { PaneElement } from "../shared/PaneElement";

const useStyles = makeStyles()((theme: Theme) => ({
    table: {
        tableLayout: "fixed",
    },
    tableCell: {
        borderBottom: `1px solid ${theme.palette.emteria.border.secondary}`,
    },
}));

interface PaneTableProps {
    firstColumn: string;
    tableItems: TableRowItem[];
    handleRemoveBatchItem: (id: number) => void;
}

interface TableRowItem {
    name?: string;
    activationCode?: string;
    id: number;
}

const PaneTable = ({ firstColumn, tableItems, handleRemoveBatchItem }: PaneTableProps) => {
    const { classes } = useStyles();
    const { t } = useTranslation(["common"]);
    const isBatchActionLicense = useSelector(selectBatchActionIsActiveLicense);
    const isBatchActionDevice = useSelector(selectBatchActionIsActiveDevice);

    return (
        <PaneElement.TableLayout contentDeps={[tableItems.length]}>
            <MinimalTable className={classes.table}>
                <MinimalTableHeader>
                    <TableRow>
                        <MinimalTableHeaderCell align="left">{firstColumn}</MinimalTableHeaderCell>
                        <MinimalTableHeaderCell align="right"></MinimalTableHeaderCell>
                    </TableRow>
                </MinimalTableHeader>
                <TableBody>
                    {tableItems.map(({ id, activationCode, name }) => {
                        return (
                            <TableRow key={id}>
                                <MinimalTableCell align="left" className={classes.tableCell}>
                                    <div>{isBatchActionLicense || isBatchActionDevice ? activationCode : name}</div>
                                </MinimalTableCell>
                                <MinimalTableCell align="right" className={classes.tableCell}>
                                    <DangerOutlinedButton
                                        onClick={() => handleRemoveBatchItem(id)}
                                        tooltipProps={{ title: t("common:button.remove") }}
                                    >
                                        <i className="fa-solid fa-trash-alt" />
                                    </DangerOutlinedButton>
                                </MinimalTableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </MinimalTable>
        </PaneElement.TableLayout>
    );
};

export default PaneTable;
